import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import PartnersApi from 'libs/api/website/partners';

const useSinglePartner = () => {
  const { id: routeId } = useParams();
  const [singleItem, setSingleItem] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!routeId) {
      return;
    }

    let cancelled = false;

    (async () => {
      setLoading(true);
      try {
        const response = await PartnersApi.show(routeId);
        const item = response.data?.success
          ? response.data.partner
          : response.data?.partner;

        if (!cancelled) {
          setSingleItem(item || {});
        }
      } catch {
        if (!cancelled) {
          setSingleItem({});
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [routeId]);

  const viewItem = useMemo(
    () => ({
      ...singleItem,
      id: singleItem?.id || routeId,
    }),
    [singleItem, routeId],
  );

  return {
    singleItem: viewItem,
    loading,
  };
};

export default useSinglePartner;
